<template>
  <v-card color="contrast_low" style="border-top-right-radius: 0;border-top-left-radius: 0">
    <v-card-text class="pa-2">
      <v-row justify="space-between">
        <v-col v-if="versionSelectedData?.metadata" cols="12">
          <p v-if="versionSelectedData.metadata.info.statuses[versionSelected.status].rejectReason"
             class="cb-font-size-4 mb-0 font-weight-medium error--text">
            <span class=""><v-icon class="mr-2" color="error"
                                   small>cancel</v-icon>Rechazado: </span>
            {{ versionSelectedData.metadata.info.statuses[versionSelected.status].rejectReason }}
          </p>
        </v-col>
        <v-col class="pa-0 px-2 align-content-center">
          <v-row>
            <v-col
              v-if="versionSelected.status !== 'draft' && versionSelected.status !== 'approved' && versionSelected.status !== 'completed'">
              <v-menu
                absolute
                right
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    color="error"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon class="mr-1">clear</v-icon>
                    <span>Rechazar</span>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-text class="px-2 pb-0">
                    <p>Introduzca el motivo del rechazo y retornar al estado anterior</p>
                    <v-textarea
                      v-model="localRejectReason"
                      hide-details
                      outlined
                      placeholder="Motivo del rechazo"
                      rows="3"
                      @click.stop
                    />
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      :disabled="localRejectReason == ''"
                      block
                      color="primary"
                      height="42px"
                      @click="rejectVersion"
                    >
                      <span>Confirmar</span>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-col>
            <v-col
              v-if="versionSelected.status === 'draft'">
              <v-btn
                id="btn-saveChecklist"
                :loading="checklistSaving"
                block
                color="primary"
                @click="$emit('save-checklist')"
              >
                <v-icon class="mr-1">save</v-icon>
                <span>Guardar</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                id="btn-updateVersionStatus"
                :disabled="hasPendingSections"
                block
                color="success"
                @click="updateToNextStatus"
              >
                <v-icon class="mr-1">check_circle</v-icon>
                <span>{{ nextStatusAction }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import model_checklist from '@/constants/models/pkc/model_checklist'

  export default {
    name: 'ChecklistVersionActions',
    props: {
      versionSelected: {
        type: Object,
        required: true
      },
      versionSelectedData: {
        type: Object,
        required: true
      },
      hasPendingSections: {
        type: Boolean,
        default: false
      },
      checklistSaving: {
        type: Boolean,
        default: false
      },
      rejectStatusReason: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        localRejectReason: this.rejectStatusReason,
        modelData: model_checklist
      }
    },
    computed: {
      nextStatus() {
        const currentIndex = this.modelData.statuses.findIndex(s => s.id === this.versionSelected.status)
        return this.modelData.statuses[currentIndex + 1] || null
      },
      previousStatus() {
        const currentIndex = this.modelData.statuses.findIndex(s => s.id === this.versionSelected.status)
        return this.modelData.statuses[currentIndex - 1] || null
      },
      nextStatusAction() {
        if (this.nextStatus && this.nextStatus.action) {
          return this.nextStatus.action
        }
        return 'Avanzar'
      }
    },
    watch: {
      rejectStatusReason(val) {
        this.localRejectReason = val
      },
      localRejectReason(val) {
        this.$emit('update:rejectStatusReason', val)
      }
    },
    methods: {
      updateToNextStatus() {
        if (this.nextStatus) {
          this.$emit('update-version-status', this.nextStatus.id)
        }
      },
      rejectVersion() {
        if (this.previousStatus) {
          this.$emit('update-version-status', this.previousStatus.id)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/resources/colors.scss";
</style>